import { render, staticRenderFns } from "./DesignTokenBtn.vue?vue&type=template&id=b1337d6c&"
import script from "./DesignTokenBtn.vue?vue&type=script&lang=js&"
export * from "./DesignTokenBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports